/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_License_Plate_InvalidInputs */

const en_case_validation_license_plate_invalid = /** @type {(inputs: Case_Validation_License_Plate_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid license plate format.`)
};

const pt_br2_case_validation_license_plate_invalid = /** @type {(inputs: Case_Validation_License_Plate_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de placa inválido.`)
};

/**
* | output |
* | --- |
* | "Invalid license plate format." |
*
* @param {Case_Validation_License_Plate_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_license_plate_invalid = /** @type {((inputs?: Case_Validation_License_Plate_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_License_Plate_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_license_plate_invalid(inputs)
	return pt_br2_case_validation_license_plate_invalid(inputs)
});